import { render, staticRenderFns } from "./UserInvestment.vue?vue&type=template&id=a261e1b0&scoped=true"
import script from "./UserInvestment.vue?vue&type=script&lang=js"
export * from "./UserInvestment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a261e1b0",
  null
  
)

export default component.exports